import type { LoaderFunctionArgs } from 'react-router';
import { COMM_MANAGER_TOKEN, container } from '@/container';
import ROUTES, { type PromiseLoaderReturnType } from '@/routes';
import { setSearchId, setSessionKey } from '@/stores/layout-status';
import { useMessageStore } from '@/stores/message';
import { getSessionById } from '@/utils/cache-session';
import { generateSessionKey } from '@/utils/session';

export async function sessionMessagesLayoutLoader({ params, request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const { searchParams } = url;
  const { search } = ROUTES.MESSAGES.SESSIONS.$deserializeSearchParams(searchParams);
  const { id } = ROUTES.MESSAGES.SESSIONS.$deserializeParams(params);
  const currentPath = url.pathname;
  const exactPath = ROUTES.MESSAGES.SESSIONS.$buildPath({ params: { id } });
  const shouldUpdateSearchId = currentPath === exactPath;

  return handleDisplaySessionMessages(id, search, shouldUpdateSearchId);
}

export async function handleDisplaySessionMessages(id: number, search?: number, shouldIpdateSearchId = false) {
  container.get(COMM_MANAGER_TOKEN)?.dispatch({
    event: 'session',
    data: { type: 'session', id },
  });

  const sessionInfo = getSessionById('session', id);
  setSessionKey(generateSessionKey('session', id));
  if (shouldIpdateSearchId) setSearchId(search);
  return {
    promises: useMessageStore.getState().hydrate({ type: 'session', id, searchId: search }),
    initialUnreadCount: sessionInfo?.UnReadCount ?? 0,
  };
}

export type SessionMessagesLayoutLoaderReturnType = PromiseLoaderReturnType & { initialUnreadCount: number };
